import Footer from 'components/Footer';
import React, { useEffect, useState, useRef } from 'react'

function Products() {
  const [selectedImage, setSelectedImage] = useState('images/제품소개00.png'); // 초기 이미지 설정
  const [activeIndex, setActiveIndex] = useState(0); // 현재 활성화된 항목의 인덱스를 관리하기 위한 상태
  const images = ['images/제품소개00.png', 'images/제품소개2.png', 'images/제품소개3.png']; // 이미지 경로 배열
  const refs = useRef([]);

  useEffect(() => {
    window.scrollTo(0, 0);

    // Intersection Observer 콜백 함수
    const observerCallback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // 요소가 뷰포트에 들어오면 'visible' 클래스 추가
          entry.target.classList.add('visible');
          observer.unobserve(entry.target); // 관찰 중단
        }
      });
    };

    // Intersection Observer 설정
    const observerOptions = {
      root: null, // 뷰포트를 기준으로
      rootMargin: '0px',
      threshold: 0.1 // 10% 이상이 보일 때 콜백 실행
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    // 모든 대상 요소에 대해 관찰 시작
    refs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => {
      // 컴포넌트 언마운트 시 관찰 중단
      refs.current.forEach((ref) => {
        if (ref) observer.unobserve(ref);
      });
    };
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => {
        const nextIndex = (prevIndex + 1) % images.length; // 다음 인덱스 계산, 배열의 끝에 도달하면 0으로 리셋
        setSelectedImage(images[nextIndex]); // 다음 이미지로 업데이트
        return nextIndex;
      });
    }, 3000); // 3초 간격으로 변경

    return () => clearInterval(interval); // 컴포넌트 언마운트 시 인터벌 정리
  }, [images]);
  const changeImage = (imagePath, index) => {
    setSelectedImage(imagePath);
    setActiveIndex(index);
  };
  return (
    <>
      <div className='product_head' >
        <div ref={(el) => (refs.current[0] = el)}>
        <h2>PRODUCTS</h2>
        <span className='sub_span about'>
          <br />
          수 년간 정부/ 공공기관/ 일반기업에 다양한 GIS Total 솔루션을 제공한 전문 GIS 기업으로 최적의 솔루션을 제공할 것을 자부합니다
        </span>
        </div>
        
      </div>

      <div className='product_div'>
        <div className='product_sub'>
          {/* <h2>PRODUCTS</h2> */}
        </div>
        <div className='product_flex' ref={(el) => (refs.current[1] = el)}>
          <div className='product_img_div'>
            <img src={selectedImage} className='product_img fade' />
          </div>
          <div className='product_con' >
            <div className='product_area'>
              <h3>eKsys의 최상의 GIS 솔루션을 경험하세요</h3>
              <ul>
                <li onClick={() => changeImage('images/제품소개00.png', 0)}
                  className={activeIndex === 0 ? 'active' : ''}>
                  GIS Total Solution
                  <span>GIS Total 솔루션 제공 (Web용/Desktop용/Mobile용) 600여 개의 SDK 제공으로 원하는 기능 쉽게 구현</span>
                </li>
                <li onClick={() => changeImage('images/제품소개2.png', 1)}
                  className={activeIndex === 1 ? 'active' : ''}>
                  LBS서비스 솔루션 제공
                  <span>다양한 LBS서비스에 솔루션제공 <br />위치정보사업자로서 다양한 관제 시스템</span>
                </li>
                <li onClick={() => changeImage('images/제품소개3.png', 2)}
                  className={activeIndex === 2 ? 'active' : ''}>
                  Map 가공 및 DB구축
                  <span>Map 가공 노하우 및 GIS 전문 인력 보유 <br />다수 기업과 전자지도 전략적 제휴</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* <div className='padding_div' /> */}

      <div className='product_explain_div' ref={(el) => (refs.current[2] = el)}>
        <h2 className='product_h2' ref={(el) => (refs.current[3] = el)}>교통약자 분야</h2>
        <div className='product_cont' ref={(el) => (refs.current[4] = el)}>
          <h3 className='product_h3'>교통약자이동지원</h3>
          <div className='product_h3_sub flex'>
            {/* 다년간의 전국 교통약자 이동지원 관제시스템 구축을 통해 국내 최다 구축실적을 보유 하고 있으며 보다 효율적인 시스템을 연구하고 끊임없는 개선을 통하여 GS인증 획득 등 시장을 선도 하고 있습니다 */}
            교통약자를 위한 차량 배차 시스템으로 사전 등록 이용자에 한하여 제공되는 서비스로 차량 예약(접수), 배차, 승하차 및 요금, 통계 등을 통합 관리하는 관제시스템 입니다
            <img className='transportation_vulnerable' src='images/교통약자이동지원 (2).png' alt='교통약자이동지원' ref={(el) => (refs.current[5] = el)} />
          </div>
        </div>
      </div>

      <div className='product_explain_div' ref={(el) => (refs.current[6] = el)}>
        <h2 className='product_h2' ref={(el) => (refs.current[7] = el)}>클라우드 분야</h2>
        <div className='product_cont' ref={(el) => (refs.current[8] = el)} >
          <h3 className='product_h3'>클라우드 관제서비스</h3>
          <div className='product_h3_sub flex'>
            교통약자 시스템을 클라우드 기반 플랫폼 환경(SaaS)에서 최고의 안정된 서비스 및 확장성을 제공하며, 이를 통해 서비스 장애를 최소화 하고, 이용 시 자체 인프라 구축이 필요하지 않아 빠른 도입이 가능합니다
            <img className='transportation_vulnerable' src='images/클라우드관제서비스_01.png' alt='wiseVCS' ref={(el) => (refs.current[9] = el)} />
            <div className='product_h3_sub flex'>
              <a href='https://www.digitalmarket.kr/web/service/detail.do?s=SAS-5-09-11356#none' 
                 className='sub_link' target='_blank'>교통약자 이동지원 클라우드 SaaS 관제서비스 확인하기</a>
              교통약자 클라우드 서비스(SaaS) 이용가이드
              <div className='flex_link'>
                <a href='pdf/교통약자이동지원_클라우드 SaaS 제품 소개.pdf'
                  // download='교통약자이동지원_클라우드 SaaS 제품 소개.pdf'
                  target='_blank'>제품소개서</a>
                  <a href='pdf/관리자 매뉴얼.pdf'
                  //  download='이용자 매뉴얼.pdf'
                  target='_blank'>관리자 매뉴얼</a>
                <a href='pdf/교통약자이동지원_이용자 매뉴얼.pdf'
                  // download='교통약자이동지원_이용자 매뉴얼.pdf'
                  target='_blank'>이용자 매뉴얼</a>
                </div>
            </div>
          </div>
        </div>
      </div>

      <div className='product_explain_div' ref={(el) => (refs.current[10] = el)} >
        <h2 className='product_h2' ref={(el) => (refs.current[11] = el)}>GIS 솔루션 분야</h2>
        <div className='product_cont' ref={(el) => (refs.current[12] = el)}>
          <h3 className='product_h3'>SmartInfo</h3>
         
          <div className='product_h3_sub'>
            <span>웹맵(Web Map) 서비스를 제공하는 솔루션으로 서버 기반의 서비스에 적합한 GIS 솔루션이며,
              Java 기반의 라이브러리 제공으로 다양한 시스템에 적용가능하며 이미지 표출, 레이어 생성 및 표시, 검색 등 다양한 기능을 제공합니다</span>
            <img className='smartinfo_bg' src='images/SmartInfo_02.png' alt='smartinfo_bg' ref={(el) => (refs.current[13] = el)}/>
          </div>
        </div>

        <div className='product_cont' ref={(el) => (refs.current[14] = el)} >
          <h3 className='product_h3'>SmartGEO</h3>
          <div className='product_h3_sub flex'>
            <span>- SmartGEO 는 공간정보의 통합 편집 Tool로서 현장조사를 바탕으로 수집된 공간데이터의 편집, 가공, 검수, 배포의 기 능을 효율적으로 제공 합니다.</span>
            <span>- 관계형 데이터 모델 지원, Vector Data, Raster 엔진 동시 탑제</span>
            <img className='smartinfo_bg' src='images/SmartGEO_02.png' alt='SmartGEO' ref={(el) => (refs.current[15] = el)} />
          </div>
        </div>

        <div className='product_cont' ref={(el) => (refs.current[16] = el)} >
          <h3 className='product_h3'>Wise Navi</h3>
          <div className='product_h3_sub flex'>
            <span>- 길안내 솔루션이 필요한 Biz 시스템에 쉽고 빠르게 Porting 할 수 있는 Open API 제공</span>
            <span>- Tmap Open API 제공은 물론 독자적인 경로 탐색 엔진을 제공하여 필요에 따라 적용 개발할 수 있는 SDK 및 기술지원</span>
            <img className='smartinfo_bg' src='images/WiseNavi02.png' alt='wiseNavi2' ref={(el) => (refs.current[17] = el)} />
          </div>
        </div>
      </div>

      <div className='product_explain_div end' ref={(el) => (refs.current[18] = el)}>
        <h2 className='product_h2' ref={(el) => (refs.current[19] = el)}>모빌리티 솔루션 분야</h2>
        <div className='product_cont' ref={(el) => (refs.current[20] = el)}>
          <h3 className='product_h3'>스마트 택시 & W-TAXI</h3>
          <div className='product_h3_sub flex'>
            <span>- 택시 예약 및 배차 시스템으로 전화 및 App을 이용한 예약 기능 제공</span>
            <span>- 고객주변의 택시에 우선배차 및 콜센터 전화연결 기능등을 제공하는 편리한 택시 예약 시스템입니다</span>
            <img className='smartinfo_bg' src='images/스마트택시.png' alt='smartTaxi' ref={(el) => (refs.current[21] = el)} />
          </div>
        </div>

        {/* <div className='product_cont' ref={(el) => (refs.current[26] = el)}>
          <h3 className='product_h3'>Wise Navi</h3>
          <div className='product_h3_sub flex'>
            <span>- 길안내 솔루션이 필요한 Biz 시스템에 쉽고 빠르게 Porting 할 수 있는 Open API 제공</span>
            <span>- Tmap Open API 제공은 물론 독자적인 경로 탐색 엔진을 제공하여 필요에 따라 적용 개발할 수 있는 SDK 및 기술지원</span>
            <img className='smartgeo_img' src='images/wiseNavi2.png' alt='LBS' ref={(el) => (refs.current[27] = el)} />
          </div>
        </div> */}
      </div>

      <Footer />
    </>
  )
}

export default Products
